const filterScripts = (scripts, query) => {
  return scripts?.filter((script) =>
    script?.name?.toLowerCase()?.includes(query.toLowerCase())
  );
};
export default filterScripts;
